import { NEWS_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const newsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNews: builder.query({
      query: ({ keyword, pageNumber, isAdminSpace, sortKey, sortDirection, parPage }) => ({
        url: NEWS_URL,
        params: { keyword, pageNumber, isAdminSpace, sortKey, sortDirection, parPage },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['News'],
    }),

    getAllNews: builder.query({
      query: () => ({
        url: NEWS_URL,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['News'],
    }),

    getNewsDetails: builder.query({
      query: ({ newsId, isAdminSpace }) => ({
        url: `${NEWS_URL}/${newsId}`,
        params: { isAdminSpace },
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, newsId) => [{ type: 'News', id: newsId }],
    }),

    createNews: builder.mutation({
      query: (data) => ({
        url: NEWS_URL,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['News'],
    }),

    updateNews: builder.mutation({
      query: (data) => ({
        url: `${NEWS_URL}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['News'],
    }),

    uploadNewsPhoto: builder.mutation({
      query: (data) => ({
        url: `/api/upload`,
        method: 'POST',
        body: data,
      }),
    }),

    deleteNews: builder.mutation({
      query: (newsId) => ({
        url: `${NEWS_URL}/${newsId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['News'],
    }),

    toggleNewsVisibility: builder.mutation({
      query: (newsId) => ({
        url: `${NEWS_URL}/${newsId}/visibility`,
        method: 'PUT',
      }),
      invalidatesTags: ['News'],
    }),
  }),
});

export const {
  useGetNewsQuery,
  useGetAllNewsQuery,
  useGetNewsDetailsQuery,
  useCreateNewsMutation,
  useUpdateNewsMutation,
  useUploadNewsPhotoMutation,
  useDeleteNewsMutation,
  useToggleNewsVisibilityMutation,
} = newsApiSlice;
